import archives from "./requests-page/archives/store";

export default {
  namespaced: true,
  modules: {
    archives
  },
};
